import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GtmService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  init(): void {
    if (!environment.enableGTM) return;

    const script = this.document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
        j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j, f);
      })(window,document,'script','dataLayer','GTM-T9BCRKWP');
    `;
    this.document.head.appendChild(script);

    const noScript = this.document.createElement('noscript');
    noScript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T9BCRKWP"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.document.body.appendChild(noScript);
  }
}
